<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul
        class="items-center gap-x-3 grid"
        style="grid-template-columns: 2fr 1fr auto"
      >
        <el-form-item
          label="所属单位"
          prop="d_belong_unit_id"
          :rules="[
            { required: true, message: '请选择所属单位', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.model.d_belong_unit_id"
            :empty-values="[null, undefined, 0]"
          >
            <el-option
              v-for="item in state.dw_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadDw"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属行业"
          prop="d_industry_id"
          :rules="[
            { required: true, message: '请选择所属行业', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.model.d_industry_id"
            :empty-values="[null, undefined, 0]"
          >
            <el-option
              v-for="item in state.hy_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadHy"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </ul>
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <ul class="items-center gap-x-3 grid grid-cols-3">
        <el-form-item
          label="联系人"
          prop="contact_name"
          :rules="[
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.contact_name"></el-input>
        </el-form-item>
        <el-form-item
          label="称谓"
          prop="contact_title"
          :rules="[{ required: true, message: '请选择称谓', trigger: 'blur' }]"
        >
          <div
            class="rounded px-3 cursor-pointer"
            :class="
              state.model.contact_title == '先生'
                ? ' bg-green-800 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.contact_title = '先生'"
          >
            先生
          </div>
          <div
            class="rounded px-3 ml-2 cursor-pointer"
            :class="
              state.model.contact_title == '女士'
                ? ' bg-red-600 text-white'
                : ' text-gray-400 border'
            "
            @click="state.model.contact_title = '女士'"
          >
            女士
          </div>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="contact_phone"
          :rules="[
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { validator: $phone_rules, trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.contact_phone"></el-input>
        </el-form-item>
      </ul>
      <ul class="items-center gap-x-3 grid grid-cols-3">
        <el-form-item label="职务">
          <el-input v-model="state.model.contact_job"></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="contact_email"
          :rules="[{ validator: $email_rules, trigger: 'blur' }]"
        >
          <el-input v-model="state.model.contact_email"></el-input>
        </el-form-item>
        <el-form-item label="微信">
          <el-input v-model="state.model.contact_wechat"></el-input>
        </el-form-item>
      </ul>
      <ul class="grid gap-x-3" style="grid-template-columns: 1fr 2fr">
        <el-form-item label="所在地">
          <el-cascader
            v-model="state.model.area"
            :options="area"
            filterable
            :props="{
              value: 'name',
              label: 'name',
            }"
            class="!w-full"
          />
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
      </ul>
      <el-form-item
        label="对接人"
        prop="belonger_id"
        :rules="[{ required: true, message: '请选择对接人', trigger: 'blur' }]"
      >
        <c_userselect
          v-model="state.model.belonger_id"
          @change:item="
            (item) => {
              state.model.belonger_department_id = item.department_id;
            }
          "
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="state.model.remark"
          type="textarea"
          :autosize="{
            minRows: 3,
          }"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import area from "@/assets/json/pca-code.json";
import { dic_getBelongUnit, dic_getIndustry } from "@/http/data";
import { billunit_detail, billunit_add, billunit_edit } from "@/http/billunit";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadDw();
      onLoadHy();
      if (props.id) {
        billunit_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.area = [data.province, data.city, data.district];
          }
        });
      }
    });

    //获取单位
    const onLoadDw = () => {
      dic_getBelongUnit().then((res) => {
        if (res.status == 200) {
          state.dw_data = res.data.data;
        }
      });
    };

    //获取单位
    const onLoadHy = () => {
      dic_getIndustry().then((res) => {
        if (res.status == 200) {
          state.hy_data = res.data.data;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.area?.length == 3) {
            state.model.province = state.model.area[0];
            state.model.city = state.model.area[1];
            state.model.district = state.model.area[2];
          }

          if (props.id) {
            billunit_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            billunit_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadDw,
      onLoadHy,
      onSubmit,
      area,
    };
  },
};
</script>
<style scoped></style>
